const timeLineElements = [
  {
    id: 1,
    title: "BS.c in Computer Science",
    company: "HIT",
    location: "Holon",
    description: "",
    date: "1/10/16 - 1/10/19",
  },
  {
    id: 2,
    title: "Android Developer",
    company: "Beatman",
    location: "Tel Aviv",
    description: "Developing Andoid apps with Java in Android studio",
    date: "20/11/19 - 17/12/20",
  },
  {
    id: 3,
    title: "Android & IOS Developer",
    company: "Matrix Medika",
    location: "Tel Aviv",
    description:
      "Developing Andoid & IOS apps with Java in Android studio and Swift in Xcode",
    date: "20/12/20 - 10/07/21",
  },

  {
    id: 4,
    title: "React Native devloper",
    company: "Velo",
    location: "Tel Aviv",
    description:
      "Developing with React Native cli, using Typescript, react-redux.",
    date: "1/1/2022 - 1/7/2022",
  },
  {
    id: 5,
    title: "React Native devloper",
    company: "My Genes",
    location: "Tel Aviv",
    description:
      "Developing with React Native in expo, using Typescript, mobx, EAS",
    date: "1/9/2022 - 1/11/2023",
  },
];

export {timeLineElements};
